/**
 * Annotates cell with duplicity metadata.
 * It requires duplicitiesProcessor cell processor.
 * 
 * @param {any} data
 * @param {any} row
 * @param {any} col
 */
export default function (data, row, col) {


    const visited = new Set();
    const duplicities = new Set();
    const result = [];

    for (let r = 0; r < data.length; r++) {
        const value = data[r][col];
        if (!value) {
            continue;
        }
        if (visited.has(value)) {
            duplicities.add(value);
        } else {
            visited.add(value);
        }
    }

    for (let r = 0; r < data.length; r++) {
        result.push({ row: r, col: col, metadata: { name: "duplicity", value: duplicities.has(data[r][col]) } });
    }

    return { metadata: result };
}


// WEBPACK FOOTER //
// ./App/components/Handsontable/functions/colduplicities.js